<template>
  <div>
        <Header-m></Header-m>
    <div class="page-contactUs-m"  @click.stop="closeShade">
    
      <div class="contactUs-part1 "></div>
        <div class="contactUs-part2">
          <div class="part2-item part2-title">重庆神缘智能科技有限公司</div>
          <div class="part2-item part2-phone">023-68663505</div>
          <div class="part2-item part2-office">邮政编码：400060</div>      
          <div class="part2-item part2-address">联系地址：重庆市江津区双福新区津马大道7号</div>
        </div>
        <div class="contactUs-btn" @click="toMap">
          去这里
        </div>
        <!-- <mt-actionsheet
          :actions="actions"
          v-model="sheetVisible">
        </mt-actionsheet> -->
    </div>
    <Menu path="/contactUs_m" ref="closeShade"></Menu>
  </div>
  

</template>
<script>
   import HeaderM from '@/components/wap/HeaderM/index.vue'
  import Menu from '@/components/wap/Menu/index.vue'
  import router from '@/router'
  import { Actionsheet } from 'mint-ui';
  export default {
    components: {
       HeaderM,
      Menu,
    },
    data() {
      return {
        actions:[       
          {name:"腾讯地图",method:()=>{
            
          }},
        ],
        sheetVisible:false,
        
      }
    },
    beforeCreate(){
      require('../../../static/js/adaptation.js')
    },
methods:{
      closeShade(){
        this.$refs.closeShade.closeShade();
      },
      toMap(){
        //this.sheetVisible=true
        window.location.href='https://apis.map.qq.com/uri/v1/marker?marker=coord:29.407429,106.269591;title:神缘科技;'

      }
    },
  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>